(() => {
  const MAX_COMPARE = 3;
  const STORAGE_KEY = 'uniway_customer_compare_products';

  const bar = document.querySelector('.js-customer-compare-bar');
  const itemsWrap = document.querySelector('.js-customer-compare-items');
  const countText = document.querySelector('.js-customer-compare-count');
  const submitButton = document.querySelector('.js-customer-compare-submit');
  const clearButton = document.querySelector('.js-customer-compare-clear');
  const collapseButton = document.querySelector('.js-customer-compare-collapse');

  if (!bar) return;

  document.body.appendChild(bar);

  const getToggles = () => document.querySelectorAll('.js-customer-compare-toggle');
  const getDataNodes = () => document.querySelectorAll('.js-customer-compare-data');

  const productMap = new Map();

  const refreshProductMap = () => {
    productMap.clear();

    getDataNodes().forEach((node) => {
      const id = Number(node.dataset.productId);

      try {
        productMap.set(id, JSON.parse(node.textContent));
      } catch (error) {
        console.warn('Invalid compare product data:', id, error);
      }
    });
  };

  const getSelected = () => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  };

  const saveSelected = (products) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(products));
  };

  const escapeHtml = (value) => {
    return String(value ?? '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  };

  const toggleCompareBar = () => {
    bar.classList.toggle('is-collapsed');
  };

  const syncCheckboxes = () => {
    const selectedHandles = getSelected().map((product) => product.handle);

    getToggles().forEach((toggle) => {
      const handle = toggle.dataset.productHandle;
      const checked = selectedHandles.includes(handle);

      toggle.checked = checked;
      toggle.defaultChecked = checked;

      if (checked) {
        toggle.setAttribute('checked', 'checked');
      } else {
        toggle.removeAttribute('checked');
      }
    });
  };

  const render = () => {
    refreshProductMap();

    const selected = getSelected();

    bar.hidden = selected.length === 0;
    document.body.classList.toggle('customer-compare-bar-active', selected.length > 0);

    syncCheckboxes();

    if (countText) {
      countText.textContent = `${selected.length} of ${MAX_COMPARE} items selected`;
    }

    if (submitButton) {
      submitButton.textContent = `Compare (${selected.length})`;
      submitButton.disabled = selected.length < 2;
    }

    const slots = [];

    selected.forEach((product) => {
      slots.push(`
        <div class="customer-compare-bar__item" data-product-id="${escapeHtml(product.id)}">
          <img src="${escapeHtml(product.image)}" alt="" loading="lazy">
          <span>${escapeHtml(product.title)}</span>
          <button
            type="button"
            class="customer-compare-bar__remove js-customer-compare-remove"
            data-product-id="${escapeHtml(product.id)}"
            aria-label="Remove product"
          >
            ×
          </button>
        </div>
      `);
    });

    const labels = [
      'Select item to compare',
      'Select second item to compare',
      'Select third item to compare',
    ];

    while (slots.length < MAX_COMPARE) {
      slots.push(`<div class="customer-compare-bar__slot">${labels[slots.length]}</div>`);
    }

    if (itemsWrap) {
      itemsWrap.innerHTML = slots.join('');
    }
  };

  document.addEventListener('change', (event) => {
    const toggle = event.target.closest('.js-customer-compare-toggle');

    if (!toggle) return;

    refreshProductMap();

    const id = Number(toggle.dataset.productId);
    const handle = toggle.dataset.productHandle;
    const product = productMap.get(id);

    let selected = getSelected();

    if (!product || !handle) return;

    if (toggle.checked) {
      if (selected.length >= MAX_COMPARE) {
        toggle.checked = false;
        alert(`You can compare up to ${MAX_COMPARE} products.`);
        return;
      }

      if (!selected.some((item) => item.handle === handle)) {
        selected.push(product);
      }
    } else {
      selected = selected.filter((item) => item.handle !== handle);
    }

    saveSelected(selected);
    render();
  });

  document.addEventListener('click', (event) => {
    const removeButton = event.target.closest('.js-customer-compare-remove');

    if (!removeButton) return;

    const id = Number(removeButton.dataset.productId);
    const selected = getSelected().filter((product) => Number(product.id) !== id);

    saveSelected(selected);
    render();
  });

  clearButton?.addEventListener('click', () => {
    saveSelected([]);
    render();
  });

  collapseButton?.addEventListener('click', (event) => {
    event.stopPropagation();
    toggleCompareBar();
  });

  bar.querySelector('.customer-compare-bar__header')?.addEventListener('click', (event) => {
    if (event.target.closest('button, a, input, label')) return;
    toggleCompareBar();
  });

  submitButton?.addEventListener('click', () => {
    const selected = getSelected();

    if (selected.length < 2) return;

    window.location.href = '/pages/compare';
  });

  render();

  window.addEventListener('pageshow', () => {
    render();

    requestAnimationFrame(() => {
      render();
    });

    window.setTimeout(render, 100);
    window.setTimeout(render, 300);
    window.setTimeout(render, 700);
  });

  window.addEventListener('focus', () => {
    render();
  });

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      render();
      window.setTimeout(render, 100);
    }
  });
})();